import React from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import SchoolList from '../components/schools/SchoolList';
import { useSchools } from '../contexts/SchoolsContext';

const Schools: React.FC = () => {
  const { schools, loading, error } = useSchools();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <SchoolList schools={schools} />
    </Box>
  );
};

export default Schools; 